// Inbox chrome stays unselectable so a drag only picks up message text; editors and fields opt back in.
export const chromeSelectionClasses =
	"select-none [&_.ProseMirror]:select-text [&_input]:select-text [&_textarea]:select-text"
